import React from 'react'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'

import PartnerStars from './PartnerStars'
import PartnerProductionTime from './PartnerProductionTime'

const PartnerCard: React.FC = () => {
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)

  if (!partner) return null

  return (
    <>
      <div className="panel card-full" style={{ width: 500, height: 284 }} /* href={href} target="__blank" */>
        <div className="row align-start card-in">
          <img src={partner.pictureMedium} alt=""/>
          <div className="grow padding-left-16">
            <div className="row justify-start">

              <PartnerStars average={partner.average} />
            </div>
            <h2 style={{ color: '#770000' }}>{partner.name}</h2>
            <p style={{ color: '#7B7B7B' }}>{ partner.description }</p>
          </div>
        </div>

        <PartnerProductionTime />
      </div>
    </>
  )
}

export default PartnerCard
